'use client'

import { Error as ErrorComponent } from '@ui/nextjs'
import cn from '@config/tailwind/cn'

import { authClient } from '~/auth/client'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <ErrorComponent locale='id' error={error} reset={reset} className={cn('min-h-[70dvh]')} auth={authClient} />
}
